// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__zG8iX","inner":"Footer_inner__wGvUA"};